import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'r-widget-button,[r-widget-button]',
  templateUrl: './r-widget-button.component.html',
  styles: []
})
export class RWidgetButtonComponent implements OnInit {
  constructor() {}

  ngOnInit() {}

  @Output() submitForm: EventEmitter<any> = new EventEmitter<any>();
  @Output() resetForm: EventEmitter<any> = new EventEmitter<any>();
  _submitForm() {
    this.submitForm.emit();
  }
  _resetForm() {
    this.resetForm.emit();
  }
}
